<template>
    <div class="body" v-loading="loading">
        <headerdd></headerdd>
        <div class="login">
            <div class="login_in">
                <div class="app" @click="downapp(true)">
                    <div class="text">
                        <img src="@/assets/img/login/down_app.png" alt />
                        <p>下载APP</p>
                    </div>
                    <img src="@/assets/img/login/down.png" alt />
                </div>
                <div class="logo"><img src="@/assets/img/login/logo.png" alt /></div>
                <div class="item">
                    <input type="number" v-model="phone" placeholder="请输入手机号" maxlength="11" />
                </div>
                <div class="item yzm">
                    <input type="number" v-model="password" placeholder="请输入验证码" />
                    <button :disabled="disabled" @click="getcid">{{ cid }}</button>
                </div>
                <button class="submit" @click="login">登 录</button>
                <div class="downapp" v-show="isdown">
                    <b @click="downapp(false)">返回登录</b>
                    <img src="http://www.haichacha.net/wechat.jpg" alt="" />
                    <p>扫码下载海查查APP</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Headerdd from "./header";
export default {
    name: "Login",
    components: {
        Headerdd,
    },
    data() {
        return {
            cid: "获取验证码",
            code: 0,
            time: 60,
            disabled: false,
            phone: "",
            password: "",
            isok: 0,
            isdown: false,
            isphone: false,
            loading: false,
            type: this.$route.query.type,  //1是销售，2是代理商
        };
    },
    mounted() { },
    methods: {
        animate() {
            var re = /^1[3-9]\d{9}$/;
            if (re.test(this.phone)) {
                this.isok = 1;
                this.isphone = true;
            } else {
                this.isphone = false;
                this.$message.error("请填写正确的手机号");
            }
        },
        downapp(bl) {
            this.isdown = bl;
        },
        getcid() {
            this.animate();
            if (this.isok == 1) {
                if (this.time == 60) this.getcidsum();
                if (this.time > 0) {
                    this.isok = 0;
                    this.cid = this.time + "s重试";
                    this.code = 1;
                    this.disabled = true;
                    this.time--;
                    setTimeout(this.getcid, 1000);
                } else {
                    this.time = 60;
                    this.code = 0;
                    this.disabled = false;
                    this.cid = "获取验证码";
                }
            }
        },
        getcidsum() {
            this.$http.get("app/sendCode", {
                params: {
                    phone: this.phone,
                    type: 3,
                },
            }).then(response => {
                if (response.status == 200) {
                    this.$message.success("验证码发送成功，请注意查收");
                }
            }).catch(function (error) { });
        },
        login() {
            this.animate();
            let json = {
                code: this.password,
                mobile: this.phone,
                platform: "web",
            };
            if (this.type == 1) {
                json.salesId = this.$route.query.id
            } else if (this.type == 2) {
                json.agentId = this.$route.query.id
            }
            if (this.isphone == true) {
                this.loading = true;
                this.$http.post("app/loginBycode", json).then(res => {
                    if (res.data.code == 0) {
                        localStorage.setItem("token", res.data.data.token);
                        this.getUserInfo();
                    } else {
                        this.loading = false;
                    }
                });
            }
        },
        getUserInfo() {
            this.$http.post("app/userInfo").then(res => {
                this.loading = false;
                if (res.data.code == 0) {
                    this.userInfo = res.data.data;
                    this.$store.commit("setUser", this.userInfo);
                    this.$message.success("登录成功");
                    this.$router.push({
                        path: "/home",
                        params: {
                            token: localStorage.getItem("token")
                        }
                    })
                }
            });
        },
    }
};
</script>

<style lang="less" scoped>
/*** 消除input元素 type="number" 时默认的 加减按钮*/

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/*** 消除input元素 type="number" 时默认的 加减按钮---moz版*/
input[type="number"] {
    -moz-appearance: textfield;
}

.body {
    background: url("../../assets/img/login/bg.jpg") no-repeat center top;
    height: 100vh;
    overflow: hidden;

    .login {
        width: 1254px;
        margin: 230px auto 0 auto;
        position: relative;
        background: url("../../assets/img/login/form_bg.jpg") bottom center
            no-repeat;
        height: 590px;

        .login_in {
            position: absolute;
            width: 464px;
            height: 545px;
            top: 0;
            right: 145px;
            background-color: #fff;
            padding: 34px;
            box-sizing: border-box;

            .logo {
                margin-top: 70px;
                margin-bottom: 38px;
                text-align: center;

                img {
                    display: inline-block;
                }
            }

            .item {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                margin-bottom: 22px;

                input {
                    width: 100%;
                    height: 54px;
                    border-radius: 4px;
                    border: solid 1px #ccc;
                    font-size: 16px;
                    padding-left: 63px;
                    box-sizing: border-box;
                    background: url("../../assets/img/login/phone.png")
                        no-repeat 29px center;
                    color: #333333;
                }

                ::-ms-clear,
                ::-ms-reveal {
                    display: none;
                }

                input::-webkit-input-placeholder {
                    /* WebKit browsers */
                    color: #a5aec4;
                }

                input:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    color: #a5aec4;
                }

                input::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    color: #a5aec4;
                }

                input::-ms-input-placeholder {
                    /* Internet Explorer 10+ */
                    color: #a5aec4;
                }

                button {
                    position: absolute;
                    right: 0;
                    top: 8px;
                    width: 120px;
                    color: #006dfd;
                    height: 40px;
                    font-size: 14px;
                    cursor: pointer;
                    border-left: #eee 1px solid;

                    &:disabled {
                        color: #a5aec4;
                    }
                }
            }

            .yzm {
                input {
                    background: url("../../assets/img/login/pwd.png") no-repeat
                        26px center;
                }
            }

            > .submit {
                width: 100%;
                height: 56px;
                margin-top: 28px;
                background: #0067fa;
                box-shadow: 0px 2px 19px 3px rgba(0, 83, 242, 0.34);
                border-radius: 4px;
                font-size: 22px;
                font-weight: bold;
                color: #ffffff;
                text-align: center;
                cursor: pointer;
            }

            .app {
                position: absolute;
                top: 0;
                right: 0;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                cursor: pointer;

                .text {
                    width: 126px;
                    height: 36px;
                    background: url("../../assets/img/login/down_bg.jpg")
                        no-repeat center center;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                    }

                    p {
                        margin-left: 8px;
                        font-size: 16px;
                        color: #61667c;
                    }
                }
            }

            .downapp {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;

                img {
                    width: 60%;
                }

                p {
                    margin-top: 30px;
                    font-size: 16px;
                }

                b {
                    display: block;
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    font-size: 14px;
                    color: #0072ff;
                    cursor: pointer;
                }
            }
        }
    }

    @media (max-width: 1366px) {
        .login {
            width: 960px;
            margin: 180px auto 0 auto;
            position: relative;
            background: url("../../assets/img/login/form_bg.jpg") center left
                no-repeat;
            height: 390px;

            .login_in {
                position: absolute;
                width: 364px;
                height: 400px;
                top: -40px;
                right: 50px;
                background-color: #fff;
                padding: 34px;
                box-sizing: border-box;

                .logo {
                    margin-top: 40px;
                    margin-bottom: 28px;
                    text-align: center;

                    img {
                        width: 160px;
                        display: inline-block;
                    }
                }

                .item {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    position: relative;
                    margin-bottom: 22px;

                    input {
                        width: 100%;
                        height: 54px;
                        border-radius: 4px;
                        border: solid 1px #ccc;
                        font-size: 16px;
                        padding-left: 63px;
                        box-sizing: border-box;
                        background: url("../../assets/img/login/phone.png")
                            no-repeat 29px center;
                        color: #333333;
                    }

                    ::-ms-clear,
                    ::-ms-reveal {
                        display: none;
                    }

                    input::-webkit-input-placeholder {
                        /* WebKit browsers */
                        color: #a5aec4;
                    }

                    input:-moz-placeholder {
                        /* Mozilla Firefox 4 to 18 */
                        color: #a5aec4;
                    }

                    input::-moz-placeholder {
                        /* Mozilla Firefox 19+ */
                        color: #a5aec4;
                    }

                    input::-ms-input-placeholder {
                        /* Internet Explorer 10+ */
                        color: #a5aec4;
                    }

                    button {
                        position: absolute;
                        right: 0;
                        top: 8px;
                        width: 100px;
                        color: #006dfd;
                        height: 40px;
                        font-size: 14px;
                        cursor: pointer;
                        border-left: #eee 1px solid;

                        &:disabled {
                            color: #a5aec4;
                        }
                    }
                }

                .yzm {
                    input {
                        background: url("../../assets/img/login/pwd.png")
                            no-repeat 26px center;
                    }
                }

                > .submit {
                    display: block;
                    width: 80%;
                    height: 40px;
                    margin: 30px auto 0;
                    background: #0067fa;
                    box-shadow: 0px 2px 19px 3px rgba(0, 83, 242, 0.34);
                    border-radius: 4px;
                    font-size: 18px;
                    font-weight: bold;
                    color: #ffffff;
                    text-align: center;
                    cursor: pointer;
                }

                .app {
                    position: absolute;
                    top: 0;
                    right: 0;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    cursor: pointer;

                    .text {
                        width: 126px;
                        height: 36px;
                        background: url("../../assets/img/login/down_bg.jpg")
                            no-repeat center center;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        img {
                        }

                        p {
                            margin-left: 8px;
                            font-size: 16px;
                            color: #61667c;
                        }
                    }
                }

                .downapp {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;

                    img {
                        width: 60%;
                    }

                    p {
                        margin-top: 30px;
                        font-size: 16px;
                    }

                    b {
                        display: block;
                        position: absolute;
                        top: 20px;
                        right: 20px;
                        font-size: 14px;
                        color: #0072ff;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}
</style>
